import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import { Modal, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { makeStyles, styled } from "@mui/styles";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import SnackBar from "../Common/SnackBar";
import { InputBase } from "@mui/material";
import AddNow from "../Buttons/AddNow";
import BuyNow from "../Buttons/BuyNow";
import BuyNFT from "../Buttons/BuyNFT";
import router from "next/router";
import { API_BASE_URL } from "../../src/constant/appConstants";
import auth from "../Layout/util/auth";
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import { setOpenKyc, setPaymentUrl } from "../../src/redux/slices/payment";
import { useSelector, useDispatch } from "react-redux";
import { ContactModal } from "./ContactModal";
import IdentityModal from "./IdentityModal";
import { setCountryCode } from "../../src/redux/slices/layout";
import { CommonContext } from "../helper/commonContext";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "500px",
    background: "#242033",
    borderRadius: "10px",
    color: "white",
    minHeight: "50%",
    "@media(max-width:480px)": {
      width: "90%",
    },
  },
  paper: {
    width: "95%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "auto",
    padding: "10px",
  },
  flex: {
    width: "95%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  select: {
    border: "white",
    color: "white",
    "&:after": {
      border: "white",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
    },
  },
  icon: {
    fill: "white",
  },
  payemntMethod: {
    border: "1px solid #FFFFFF",
    borderRadius: "8px",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    minHeight: "50px",
    padding: "0 10px",
    alignItems: "center",
    "& p": {
      fontSize: "16px",
      padding: "10px",
      "@media(max-width:480px)": {
        fontSize: "14px",
      },
    },
  },
  ellipse: {
    height: "50px",
    width: "50px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    background: "#2D293A",
    borderRadius: "50%",
    "@media(max-width:480px)": {
      width: "70px",
      padding: "2px",
    },
  },
  active: {
    borderRadius: "50%",
    height: "20px",
    width: "20px",
    border: "5px solid transparent",
    background: "linear-gradient(180deg,#B237F6,#E94177) border-box",
    WebkitMask:
      "linear-gradient(#B237F6 0 0) padding-box, linear-gradient(#E94177 0 0)",
    WebkitMaskComposite: "xor",
  },
  inActive: {
    borderRadius: "50%",
    height: "20px",
    width: "20px",
    border: "2px solid #fff",
  },
  gradText: {
    background: "-webkit-linear-gradient(#B237F6,#E94177)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

const TextField1 = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    borderRadius: 4,
    backgroundColor: "transparent",
    border: "1px solid #FFF",
    fontSize: 16,
    width: "80px",
    padding: "10px 12px",
    color: "#fff !important",
    fontColor: "#fff !important",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      borderColor: "#fff",
      color: "#FFF",
    },
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: "transparent",
    border: "1px solid white",
    fontSize: 14,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    color: "white",
  },
  "& .MuiSvgIcon-root": {
    color: "white",
  },
}));
export default function PaymentModal(props) {
  console.log(
    "🚀 ~ file: PaymentModal.js ~ line 145 ~ PaymentModal ~ props",
    props
  );
  // const {paymentUrl} = useSelector(state=>state.payment)
  const commonContext = useContext(CommonContext);
  const { country_code } = useSelector((state) => state.layout);

  const dispatch = useDispatch();

  const classes = useStyles();

  const [snackbar, setSnackbar] = useState({
    show: false,
    status: "",
    message: "",
  });
  const toggleSnackbar = (value) => {
    setSnackbar(value);
  };
  const [payMethod, setPayMethod] = React.useState(1);
  const handleChange = (event) => {
    setPayMethod(event.target.value);
    if (event.target.value == 1) {
      dispatch(setCountryCode("IN"));
    }
    if (event.target.value == 4) {
      dispatch(setCountryCode("OTHER"));
    }
    console.log("payment method: ", event.target.value);
  };
  const [isRazorPay, setIsRazorPay] = useState(true);
  // const balance = 250;

  const Balance = localStorage.getItem("walletBalance");
  const [addFund, setAddFund] = useState();
  useEffect(() => {
    setAddFund(localStorage.getItem("Totaladdfund"));
  }, []);

  const [openIdentityModal, setOpenIdentityModal] = useState(false);

  var Money = Math.abs(props.Netbalance);

  const [aMount, setAmount] = useState(0);

  useEffect(() => {
    if (country_code == "IN") {
      setPayMethod(1);
    } else {
      setPayMethod(4);
    }
  }, [country_code]);

  useEffect(() => {
    if (payMethod == 1) {
      setAmount(
        Math.round(Money * parseFloat(process.env.NEXT_PUBLIC_DOLLAR_RATE))
      );
    } else {
      setAmount(Money);
    }
  }, [payMethod, Money]);

  console.log("DOLLAR RATE ", parseFloat(process.env.NEXT_PUBLIC_DOLLAR_RATE));

  return (
    <>
      <div className={classes.root}>
        <div className={classes.paper}>
          <div
            style={{
              padding: "20px 0px",
              borderBottom: "1px solid rgba(255, 255, 255, 0.5)",
            }}
            className={classes.flex}
          >
            <Typography variant="h5">Add Funds</Typography>
            {country_code == "IN" && (
              <Typography variant="body1" style={{ textAlign: "right" }}>
                Wallet Balance <br />₹{Math.round(Balance * 80)}
              </Typography>
            )}
            {country_code == "OTHER" && (
              <Typography variant="body1" style={{ textAlign: "right" }}>
                Wallet Balance <br />${Balance}
              </Typography>
            )}
          </div>
          <div
            style={{
              padding: "20px 0px",
            }}
            className={classes.flex}
          >
            <Typography variant="subtitle1">Payment Method</Typography>
            <FormControl variant="standard">
              <Select
                labelId="select-country-label"
                id="select-country-select"
                value={payMethod}
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <MenuItem value={1}>India</MenuItem>
                <MenuItem value={2}>Rest of the world</MenuItem>
              </Select>
            </FormControl>
          </div>
          {payMethod == 1 && (
            <div
              style={{
                padding: "10px 0px",
                cursor: "pointer",
              }}
              className={classes.flex}
              onClick={() => setIsRazorPay(true)}
            >
              <div className={classes.payemntMethod}>
                <div className={classes.ellipse}>
                  <img
                    style={{ objectFit: "contain", margin: "auto" }}
                    src="/images/payment/credit.png"
                  />
                </div>
                <Typography component="p">
                  Debit card, Credit card, UPI, or NetBanking
                </Typography>
                <div
                  className={isRazorPay ? classes.active : classes.inActive}
                ></div>
              </div>
            </div>
          )}
          {payMethod == 4 && (
            <div
              style={{
                padding: "10px 0px",
                cursor: "pointer",
              }}
              className={classes.flex}
              onClick={() => setIsRazorPay(true)}
            >
              <div className={classes.payemntMethod}>
                <div className={classes.ellipse}>
                  <img
                    style={{ objectFit: "contain", margin: "auto" }}
                    src="/images/payment/credit.png"
                  />
                </div>
                <Typography variant="body1">Debit card, Credit card</Typography>
                <div
                  className={isRazorPay ? classes.active : classes.inActive}
                ></div>
              </div>
            </div>
          )}
          <div
            style={{
              padding: "10px 0px",
              cursor: "pointer",
            }}
            className={classes.flex}
            onClick={() => setIsRazorPay(false)}
          >
            {/* <div className={classes.payemntMethod}>
                <div className={classes.ellipse}>
                  <img
                    style={{ objectFit: "contain", margin: "auto" }}
                    src="/images/payment/btc.png"
                  />
                </div>
                <Typography variant="body1">
                  BTC, ETH, USD on Mainnet{" "}
                </Typography>
                <div
                  className={isRazorPay ? classes.inActive : classes.active}
                ></div>
              </div> */}
          </div>
          <div
            style={{
              padding: "5px 0px",
            }}
            className={classes.flex}
          >
            <Typography variant="subtitle1">
              Add Fund to your account
            </Typography>
          </div>
          <div
            style={{
              padding: "10px 0px",
            }}
            className={classes.flex}
          >
            {commonContext?.sourcePaymentFlow == "wallet" ? (
              <>
                <Typography variant="subtitle1">Enter Amount</Typography>
                <TextField1
                  id="outlined-basic"
                  label="Amount"
                  variant="outlined"
                  value={aMount}
                  onChange={(e) => {
                    var decimal = /^\d*\.?\d*$/;
                    if (
                      e.target.value == "" ||
                      e.target.value == "." ||
                      e.target.value.match(decimal)
                    ) {
                      setAmount(e.target.value);
                      setAddFund(parseInt.apply(e.target.value));
                    }
                  }}
                />
              </>
            ) : (
              <>
                <Typography variant="subtitle1">Amount</Typography>
                <Typography label="Amount" variant="subtitle1">
                  {aMount}
                </Typography>
              </>
            )}
          </div>
          <div
            style={{
              padding: "5px 0px",
              borderBottom: "1px solid rgba(255, 255, 255, 0.5)",
            }}
            className={classes.flex}
          >
            <Typography variant="subtitle1">Service Fee</Typography>
            {country_code == "IN" && (
              <Typography variant="subtitle1">₹ 0</Typography>
            )}
            {country_code == "OTHER" && (
              <Typography variant="subtitle1">$ 0</Typography>
            )}
          </div>
          <div
            style={{
              padding: "10px 0px",
            }}
            className={classes.flex}
          >
            <Typography variant="body1">Total</Typography>
            {country_code == "IN" && (
              <Typography variant="h6">₹ {aMount}</Typography>
            )}
            {country_code == "OTHER" && (
              <Typography variant="h6">$ {aMount}</Typography>
            )}
          </div>
          <div
            style={{
              padding: "10px 0px",
            }}
            className={classes.flex}
          >
            <div
              style={{
                margin: "0px 10px",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => props.handleClose2()}
            >
              <KeyboardBackspaceIcon />
              <Typography
                ml={1}
                mr={1}
                className={classes.gradText}
                variant="h6"
              >
                Back
              </Typography>
            </div>
            {/* {process.env.NEXT_PUBLIC_ACTIVE_PAYMENT_GATEWAY =='RAZORPAY' ? 
               <AddNow
                  isRazorPay={isRazorPay}
                  amount={aMount}
                  text={"Add Funds"}
                /> :process.env.NEXT_PUBLIC_ACTIVE_PAYMENT_GATEWAY =='CASHFREE'?
                <AddNow
                  isRazorPay={isRazorPay}
                  amount={aMount}
                  text={"Add Funds"}
                  onClick={()=>{AddFunds('cashfree')}}
                />:process.env.NEXT_PUBLIC_ACTIVE_PAYMENT_GATEWAY =='STRIPE'?
                <AddNow
                amount={aMount}
                text={"Add Funds"}
                onClick={()=>{AddFunds('stripe')}}
                />:null} */}

            {payMethod == 3 ? (
              <AddNow
                amount={(
                  aMount / parseFloat(process.env.NEXT_PUBLIC_DOLLAR_RATE)
                ).toFixed(2)}
                text={"Add Funds"}
                paymentGateway={"razorpay"}
                // nftCount={count}
                handleClose2={props.handleClose2}
                tokenName={props.tokenName}
                tokenCategory={props.tokenCategory}
                tokenPrice={props.tokenPrice}
                tokenOwnership={props.tokenOwnership}
              />
            ) : payMethod == 2 ? (
              <AddNow
                paymentGateway={"stripe"}
                amount={aMount}
                text={"Add Funds"}
                handleClose2={props.handleClose2}
                tokenName={props.tokenName}
                tokenCategory={props.tokenCategory}
                tokenPrice={props.tokenPrice}
                tokenOwnership={props.tokenOwnership}
              />
            ) : payMethod == 1 ? (
              <AddNow
                paymentGateway={"cashfree"}
                amount={aMount / 80}
                text={"Add Funds"}
                handleClose2={props.handleClose2}
                tokenName={props.tokenName}
                tokenCategory={props.tokenCategory}
                tokenPrice={props.tokenPrice}
                tokenOwnership={props.tokenOwnership}
              />
            ) : payMethod == 4 ? (
              <AddNow
                paymentGateway={"fracto"}
                amount={aMount}
                text={"Add Funds"}
                handleClose2={props.handleClose2}
                tokenName={props.tokenName}
                tokenCategory={props.tokenCategory}
                tokenPrice={props.tokenPrice}
                tokenOwnership={props.tokenOwnership}
              />
            ) : null}
          </div>
        </div>
      </div>
      <ContactModal
        onContinue={() => {
          setOpenIdentityModal(true);
        }}
      />
      <IdentityModal
        openModal={openIdentityModal}
        handleModalClose={() => {
          setOpenIdentityModal(false);
        }}
      />
      {snackbar.show ? (
        <SnackBar {...snackbar} onClose={toggleSnackbar} />
      ) : null}
    </>
  );
}
